import { TilemapEditsManager } from "../../GameMap/TilemapEditsManager";
import type { WamFile } from "../../GameMap/WamFile";
import { Command } from "../Command";

export class CreateTileLayerCommand extends Command {
    protected wamFile: WamFile;

    constructor(
        wamFile: WamFile,
        protected readonly layerId: number,
        protected readonly name: string,
        protected readonly index: number,
        protected readonly opacity: number,
        protected readonly visible: boolean,
        commandId?: string,
    ) {
        super(commandId);
        this.wamFile = wamFile;
    }

    public execute(): Promise<void> {
        const overlay = TilemapEditsManager.getOrCreateOverlay(this.wamFile.getWam());
        overlay.layerEdits.push({
            action: "create",
            layerId: this.layerId,
            name: this.name,
            index: this.index,
            opacity: this.opacity,
            visible: this.visible,
        });
        return Promise.resolve();
    }
}
